<template lang='pug'>
div
    .modal-backdrop(@click='close')
        .modal-dialog(@click.stop='', :style='{ width }')
            .modal-header(:style='[title ? "" : { justifyContent: "flex-end" } ]')
                .modal-title(v-if='title')
                    span(v-html='title')
                .modal-close(@click='close')
                    .mdi.mdi-close
            .modal-slot-content
                slot
</template>

<script>
export default {
    name: 'ModalComponent',

    props: {
        title: {
            type: String,
            required: true,
        },
        width: {
            type: String,
            default: '',
        },
    },

    methods: {
        close() {
            this.$emit('close');
            this.$destroy();
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/styles/variaveis.scss';

.modal-backdrop {
    background: $backdrop-color;
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.modal-dialog {
    background: $white;
    padding: 10px 20px 20px 20px;
    box-shadow: 0 10px 15px -3px $clear-day;
    border-radius: 5px;
    position: relative;
    max-height: calc(100vh - 40px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.modal-slot-content {
    overflow-y: auto;
    flex: 1;
    min-height: 0;
}

.modal-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    border-bottom: 1px solid $default-color;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 10px;
    margin-left: -20px;
    margin-right: -20px;
}

.modal-footer {
    width: 100%;
    display: flex;
    justify-content: space-between;

    border-top: 1px solid $default-color;
    padding-top: 10px;
}

.modal-close {
    display: flex;
    justify-content: center;
    align-items: center;
    fill: $emperor;
    width: 20px;
    height: 20px;
    border-radius: 50%;
}

.modal-close:hover {
    fill: $boulder;
    background-color: $bg-color;
    cursor: pointer;
}

.modal-title {
    text-align: left;
    font-size: 18px;
    color: $primary-color;
}
</style>
